const accessoiresItem = [...document.querySelectorAll('.footerColumn--navigation li a span')]
  .find(item => item.textContent === 'Accessoires');

if (accessoiresItem) {
  accessoiresItem.remove();
} else {
  console.log('Element not found!');
}

const ul1 = document.querySelector('.footerColumn--navigation ul');
const ul2 = document.querySelectorAll('.footerColumn--navigation ul')[1];
const linkToMove = ul2.querySelector('a[href="https://www.dorsoo.be/nl/accessoires/ergonomische-hoofdkussens"]');
const destinationLi = ul1.querySelectorAll('li')[2];

destinationLi.insertBefore(linkToMove, destinationLi.firstChild);
